module.exports = __webpack_public_path__ + "img/sdg12.ff174bc1.svg";